import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-pressed", "aria-label"]

interface Props {
  active: boolean
  label?: string
}
interface Emits {
  (e: 'toggle'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    active: { type: Boolean },
    label: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["toggle-switch", { 'toggle-switch--on': props.active }]),
    "aria-pressed": props.active,
    "aria-label": props.label,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("span", { class: "toggle-switch__thumb" }, null, -1)
  ]), 10, _hoisted_1))
}
}

})